"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.header6), {}, (0, _defineProperty2.default)({
      marginLeft: '.5rem',
      fontWeight: 600,
      color: theme.colors.black,
      '&:hover, &:focus, &:active': {
        color: theme.colors.battleshipGrey
      }
    }, theme.breakpoints.gte.mobile.portrait, _objectSpread(_objectSpread({}, theme.typography.header5), {}, {
      marginLeft: '1.125rem'
    }))),
    active: {
      fontWeight: 700
    }
  };
});
/*:: type Props = {
  to: string,
  children: string | React.Element<typeof FormattedMessage>
};*/
var NavLogo = function NavLogo(_ref /*:: */) {
  var children = _ref /*:: */.children,
    to = _ref /*:: */.to;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_reactRouterDom.NavLink, {
    to: to,
    className: classes.root,
    activeClassName: classes.active
  }, children);
};
NavLogo.displayName = 'NavLogo';
NavLogo.defaultProps = {
  to: '/'
};
var _default = exports.default = NavLogo;
//# sourceMappingURL=NavLink.js.map